import { render } from "./FormOptions.vue?vue&type=template&id=1a013890"
import script from "./FormOptions.vue?vue&type=script&lang=js"
export * from "./FormOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__